import { UPDATE_STEP_COUNT } from '../../helper/constants';

const initialState = {
    step: 0
}

export default (state = initialState, {type, payload}) => {
    switch(type) {
        case UPDATE_STEP_COUNT: {
            return {
                ...state,
                step: payload
            }
        }
        default:
            return state;
    }
}
